import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Actions from "../../../../components/Actions";
import LetterAvatar from "../../../../components/LetterAvatar";
import { useNavigate } from "react-router-dom";

const Row = ({ item, onJustify, onUnjustify }) => {
    const navigate = useNavigate();
    
    // Extraire prénom et nom depuis studentName
    const nameParts = (item.studentName || '').trim().split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    // Actions pour justifier/déjustifier
    const actions = item.justification 
        ? [
            {
                title: "Retirer la justification",
                action: () => onUnjustify && onUnjustify(item)
            },
            {
                title: "Voir le profil élève",
                action: () => item.studentId && navigate(`/admin/students/${item.studentId}`)
            }
        ]
        : [
            {
                title: "Marquer comme justifiée",
                action: () => onJustify && onJustify(item)
            },
            {
                title: "Voir le profil élève",
                action: () => item.studentId && navigate(`/admin/students/${item.studentId}`)
            }
        ];

    // Formater les horaires depuis une datetime ISO (sans conversion timezone)
    const formatTime = (datetime) => {
        if (!datetime) return '';
        try {
            const date = new Date(datetime);
            const hours = date.getUTCHours().toString().padStart(2, '0');
            const minutes = date.getUTCMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        } catch {
            return '';
        }
    };

    const timeDisplay = item.startTime && item.endTime 
        ? `${formatTime(item.startTime)} - ${formatTime(item.endTime)}`
        : 'Non spécifié';

    return (
        <div className={styles.row}>
            {/* Élève */}
            <div className={styles.col}>
                <div 
                    className={styles.studentItem}
                    onClick={() => item.studentId && navigate(`/admin/students/${item.studentId}`)}
                    style={{ cursor: item.studentId ? 'pointer' : 'default' }}
                >
                    <div className={styles.avatar}>
                        <LetterAvatar firstName={firstName} lastName={lastName} size={40} />
                    </div>
                    <div className={styles.studentName}>
                        {item.studentName}
                    </div>
                </div>
            </div>

            {/* Séance */}
            <div className={styles.col}>
                <div className={styles.sessionName}>
                    {item.sessionName}
                </div>
            </div>
            
            {/* Formateur */}
            <div className={styles.col}>
                <div className={styles.teacherName}>
                    <span>{item.teacherName}</span>
                </div>
            </div>
            
            {/* Date */}
            <div className={styles.col}>
                <div className={styles.date}>
                    <span>{item.date}</span>
                </div>
            </div>
            
            {/* Horaires */}
            <div className={styles.col}>
                <div className={styles.time}>
                    {timeDisplay}
                </div>
            </div>
            
            {/* Justification */}
            <div className={styles.col}>
                <div className={cn(styles.status, item.justification ? styles.statusGreen : styles.statusRed)}>
                    {item.justification ? 'Justifiée' : 'Non justifiée'}
                </div>
            </div>

            {/* Actions */}
            <div className={styles.col}>
                <Actions
                    className={styles.actions}
                    classActionsHead={styles.actionsHead}
                    items={actions}
                    small
                />
            </div>
        </div>
    );
};

export default Row;
